import React from 'react';
import { Icon, IconClose, IconArrowUp, IconArrowDown } from '@flixbus/honeycomb-icons-react';
import Button from '../../../../components/button/button.js';

function ComboboxControllers(_ref) {
  let {
    className,
    toggleProps,
    resetProps,
    disabled
  } = _ref;
  const controllerProps = {
    size: 'sm',
    appearance: 'link',
    display: 'square',
    onMouseDown: e => e.preventDefault() // prevents hijacking combobox focus
  };
  const resetButton = resetProps && (/*#__PURE__*/React.createElement(Button, Object.assign({
    disabled: disabled
  }, controllerProps, resetProps), /*#__PURE__*/React.createElement(Icon, {
    InlineIcon: IconClose,
    size: 4,
    appearance: "primary",
    "aria-hidden": "true"
  })));
  const popupIndicator = toggleProps && (/*#__PURE__*/React.createElement(Button, Object.assign({
    disabled: disabled
  }, controllerProps, toggleProps), /*#__PURE__*/React.createElement(Icon, {
    InlineIcon: toggleProps['aria-expanded'] ? IconArrowUp : IconArrowDown,
    size: 4,
    appearance: "primary",
    "aria-hidden": "true"
  })));
  if (!resetButton && !popupIndicator) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, resetButton, popupIndicator);
}
ComboboxControllers.displayName = 'ComboboxControllers';

export { ComboboxControllers };
